import { LogIn, LogOut, Mail } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { View, XStack } from "tamagui";
import { AccountSheetActive } from "../plans/PlanModel";
import { Body } from "../ui/Body";
import { Box } from "../ui/Box";
import { Button } from "../ui/Button";
import { PopoverConfirm } from "../ui/PopoverConfirm";
import { Title } from "../ui/Title";
import { LoginSheets } from "./account/LoginSheets";
import { signOutFromApp } from "./firebaseInit";
import { useStores } from "./stores";

export const SignInSignOutBox: React.FC = observer(() => {
  const { t } = useTranslation();
  const { sessionStore } = useStores();

  const [showSheet, setShowSheet] = React.useState(AccountSheetActive.None);

  let content = null;

  if (sessionStore.isLoggedIn && sessionStore.isRegistered) {
    content = (
      <PopoverConfirm
        placement="top"
        confirmTitle={t("sign_in_box_confirm_title")}
        type="warning"
        confirmDescription={t("sign_in_box_confirm_description")}
        onConfirm={signOutFromApp}
      >
        <Button marginTop="$largest" type="secondary" icon={LogOut}>
          {t("sign_in_box_sign_out")}
        </Button>
      </PopoverConfirm>
    );
  } else {
    content = (
      <View>
        <Box>
          <XStack gap="$medium" alignItems="center">
            <LogIn />
            <Title>{t("sign_in_box_returning_user")}</Title>
          </XStack>
          <Body>{t("sign_in_box_returning_user_message")}</Body>
        </Box>
        <Button
          type="secondary"
          icon={Mail}
          onPress={() => {
            setShowSheet(AccountSheetActive.Login);
          }}
        >
          {t("sign_in_box_sign_in")}
        </Button>
      </View>
    );
  }

  return (
    <>
      {content}
      <LoginSheets currentSheet={showSheet} onChangeSheet={setShowSheet} />
    </>
  );
});
